import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs";

export default function Managers() {
  return (
    <section className="contacts patients">
      <Breadcrumbs />
      <h1 className="contacts__title history__title">Пациентам</h1>

      <div>
        <div>
          <h3 className="about-nii__title antiCorruption__title">
            Директор ГБУ СО "УрНИИДВиИ" профессор, д.м.н. Кунгуров Николай
            Васильевич
          </h3>
          <p className="dissertation__text">
            Прием граждан: вторая, четвертая неделя месяца (среда с 9:00 -
            11:00)
          </p>
          <p className="dissertation__text">
            Тел. приемной +7 (343) 218-33-71<br></br>e-mail:
            n.kungurov@gmail.com
          </p>
        </div>

        <div>
          <h3 className="about-nii__title antiCorruption__title">
            Заместитель директора по научной работе ГБУ СО "УрНИИДВиИ"
            профессор, д.м.н. Зильберберг Наталья Владимировна
          </h3>
          <p className="dissertation__text">
            Прием граждан: вторая, четвертая неделя месяца (понедельник, среда
            9:00 - 11:00)
          </p>
          <p className="dissertation__text">
            Тел. +7 (343) 218-95-70<br></br>e-mail: nauka-urnii@mail.ru
          </p>
        </div>

        <div>
          <h3 className="about-nii__title antiCorruption__title">
            Зав. клиникой, к.м.н. Гришаева Елена Владимировна
          </h3>
          <p className="dissertation__text">
            Прием граждан: еженедельно (среда 10:00 - 12:00)
          </p>
          <p className="dissertation__text">
            Тел. +7 (343) 218-33-70<br></br>e-mail: egrishaeva@yandex.ru
          </p>
        </div>
      </div>
    </section>
  );
}
